import { StoreSlice } from "../types/StoreSlice";
import IProduct from "../types/IProduct";

export type ICacheProduct = IProduct & {
  label: string;
  value: string;
  group?: string;
};

export interface ICacheSlice {
  products: Map<string, ICacheProduct>;
  setProducts: (records: Map<string, ICacheProduct>) => void;
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const createCacheSlice: StoreSlice<ICacheSlice> = (set, get) => {
  const initialState = {
    products: new Map<string, ICacheProduct>(),
  };

  return {
    ...initialState,
    setProducts: (records: Map<string, ICacheProduct>) => {
      set({ products: records });
    },
  };
};
